import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { isGlobalConnectFinland } from '../utils/communication-operator.util';

@Injectable()
export class ApiBaseHttpInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const apiUrl = getApiUrlBasedOnCommunicationOperator();
    if (isApiCall(req.url)) {
      // Add country specific base Api Url

      const modifiedRequest = req.clone({
        url: apiUrl + req.url,
      });

      // send cloned request with header to the next handler.
      return next.handle(modifiedRequest);
    }
    return next.handle(req);
  }
}

function isApiCall(url: string): boolean {
  return url.startsWith(environment.backendBaseUrl);
}

function getApiUrlBasedOnCommunicationOperator(): string {
  const HTTPS = 'https://';
  if (isGlobalConnectFinland()) {
    return HTTPS + environment.globalConnectFi.backendHost;
  }
  return HTTPS + environment.globalConnectSe.backendHost;
}
